// TODO https://youtrack.scorewarrior.dev/issue/P3-36997/P3-Site-Remove-handlers
export class EventBankClosedHandler {
    public handle(): void {
        return;
    }
}
